// extracted by mini-css-extract-plugin
export default {"bg":"Bookmarks_bg__Dxn85","title":"Bookmarks_title__CqCub","cards":"Bookmarks_cards__6HxXb"};